<template> 
    <aside :id="right ? 'right-sidebar' : 'sidebar-left'" :style="widthChanger"
        style="transition: none; height: 100%" 
        class="table-resize-reset sup-resize-stop resize-stop maintree"
        :class="[right ? 'control-sidebar control-sidebar-dark wtree_right' : 'main-sidebar pull-left sidebar-primary wtree_left']">
        <!-- sidebar: style can be found in sidebar.less -->
        <section class="sidebar" style="padding: 0px;" :style="'margin-left:' + (right ? '0px' : '50px') +';'">
            <!-- Sidebar Menu and Search Menu-->
            <li id="buttons.resize_wrapper" class="header" 
              :style="'z-index: 9999; list-style: none; color: #999; padding: 0px; margin-bottom: 2px; position: absolute;'+ pos_string">
                  
                <!-- pulsante di resize allineato a sinistra-->
                <dynButton v-if="!right" :configs="{ID: 'buttons.resize', visible: true}"
                  btnClasses="resize-start" :icon="$root.icons.h_resize"
                  @invisible="hide('buttons.resize_wrapper')"
                  :styleObj="{
                      'border-width':'2px', 
                      //'border-top-right-radius': '35%',
                      //'border-bottom-right-radius': '35%',
                      //'border-left-style': 'none', 'border-right-style': 'solid',
                      'border-color':'#999',
                      'position':'fixed', 'top': '57px',
                      'width': '28px', 'height': '30px', 'padding': '1px', 'float': 'right', 
                      'cursor': 'w-resize', 'background-color': '#666', 'color': 'white'}">
                  </dynButton>

                <!-- pulsante di resize allineato a destra-->
                <div v-if="right" class="right-btn-wrapper" style="position: fixed; top: 50px;">
                  <dynButton :configs="{ID: 'buttons.resize', visible: true}"
                    btnClasses="resize-start" :icon="$root.icons.h_resize"
                    @invisible="hide('buttons.resize_wrapper')"
                    :styleObj="{
                        'border-width':'2px', 
                        //'border-top-left-radius': '35%',
                        //'border-bottom-left-radius': '35%',
                        //'border-left-style': 'solid', 'border-right-style': 'none',
                        'border-color':'#999',
                        'position':'absolute', 'right': '0px',
                        'width': '28px', 'height': '30px', 'padding': '1px', 'float': 'right', 
                        'cursor': 'w-resize', 'background-color': '#666', 'color': 'white'}">
                    </dynButton>
                </div>
            </li>
            <!--<transition-group name='fade-roll'>-->
              <search-menu v-if="showSearchMenu" :right="right" key="2"/>
              <sidebar-menu v-show="showSidebarMenu" :right="right" key="1"/> 
            <!--</transition-group>-->
            <!-- /.sidebar-menu and ./search-menu-->
        </section>
        <!-- /.sidebar -->
    </aside>
</template>
<script>
import SidebarMenu from "./SidebarMenu";
import SearchMenu from "./SearchMenu";
import Datepicker from "vuejs-datepicker";
import dynButton from "./dynamic/DynButton.vue";

import { eventBus } from "../eventbus.js";

export default {
  name: "Sidebar",
  props: {
    right: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      if (!this.$Behaviors.expanded) { //se, da behaviors, la sidebar deve essere non espansa, applico la classe collapse
        // la classe sidebar-collapse applicata al body agisce sulla visualizzazione dell'albero
        $("body").addClass("sidebar-collapse");
      }
    });
  },
  created: function() {
    var vm = this;
    eventBus.$on("openSearchMenu", function() {
      vm.showSearchMenu = true;
      vm.showSidebarMenu = false;
      //vm.monitorRouting()
    });

    eventBus.$on("openSidebarMenu", function() {
      vm.showSidebarMenu = true;
      vm.showSearchMenu = false;
      vm.monitorRouting()
    });
  },
  components: {
    SidebarMenu,
    SearchMenu,
    datepicker: Datepicker,
    dynButton
  },
  data: function() {
    return {
      showSearchMenu: false,
      showSidebarMenu: true,
      filter: {
        descrizione: "",
        d_da: "",
        d_a: "",
        m_da: "",
        m_a: ""
      },
      advanced: false,
      msg: "tool",
      pos_string: this.right ? "left: 0px" : "right: 28px"
    };
  },
  watch: {
    advanced: function() {
      if (this.advanced) {
        this.resetFilter();
      }
    }
  },
  computed: {
    widthChanger: function() {
      if (this.showSearchMenu) {
        if (this.right) {
          $(".content-wrapper").css("margin-right", 600);
          return "width: 600px;";
        } else {
          $(".content-wrapper").css("margin-left", 600);
          return "width: 600px;";
        }
      } else {
        /* if (this.right) {
          $(".content-wrapper").css("margin-right", 350);
          return "width: 350px;";
        } else {
          $(".content-wrapper").css("margin-left", 350);
          return "width: 350px;";
        } */
        if (this.right) {
          $(".content-wrapper").css("margin-right", this.$Components["sidebar.tree"].width);
          return "width: "+this.$Components["sidebar.tree"].width+"px;"
        } else {
          $(".content-wrapper").css("margin-left", this.$Components["sidebar.tree"].width);
          return "width: "+this.$Components["sidebar.tree"].width+"px;"
        }
      }
    }
  },
  methods: {
    emitFilter: function() {
      eventBus.$emit("filter", this.filter);
      this.advanced = false;
    },
    bindDate: function(from, $event) {
      if (from) {
        if ($event) {
          this.filter.d_da = Date.parse($event);
        } else {
          this.filter.d_da = "";
        }
      } else {
        if ($event) {
          this.filter.d_a = Date.parse($event);
        } else {
          this.filter.d_a = "";
        }
      }
    },
    monitorRouting: function(){
      // se non ci sono già, navigo al dettaglio del nodo attivo
      var current = this.$route.name;
      if(!current || (current != 'wrapper' && current != "wrapper_focus") ){
        var active = this.$store.getters.getActive;
        if(active)this.$root.navigateTo(active.father.sid, active.father.fid);
      }
    }
  }
};
</script>
<style>
  .user-panel .image img {
    border-radius: 50%;
  }

  .vdp-datepicker__calendar {
    position: fixed !important;
    font-size: initial;
  }

  .sx.vdp-datepicker {
    float: left;
  }

  .dx.vdp-datepicker {
    float: right;
  }

  .vdp-datepicker.hidden-xs {
    width: 50%;
  }

  .vdp-datepicker.visible-xs-block {
    width: 100%;
  }

  .vdp-datepicker input {
    width: 100%;
    color: #999 !important;
    padding: 6px 12px;
  }

  .dx.vdp-datepicker input {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }

  .vdp-datepicker__clear-button {
    position: absolute;
    top: 0px;
    right: 8px;
  }

  span.day.selected {
    color: white;
    background: #999 !important;
  }

  .tooltip {
    display: block !important;
    padding: 4px;
    z-index: 10000;
  }

  .tooltip .tooltip-inner {
    color: #111;
    border: 1px solid #dca;
    background: #fffaf0;
    font-weight: 600;
    border-radius: 4px;
    padding: 5px 10px 4px;
  }

  .tooltip tooltip-arrow {
    display: none;
  }

  .tooltip[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  .tooltip[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
</style>
<style scoped>
  aside.control-sidebar {
    min-height: 100%;
    z-index: 810;
  }

  #right-sidebar {
    right: 0px;
  }

  .fade-roll-enter {
    opacity: 0;
  }

  .fade-roll-enter-active {
    animation: slide-in 0.3s ease-out forwards;
    transition: opacity 0.3s;
  }

  .fade-roll-leave-active {
    animation: slide-out 0.3s ease-out forwards;
    transition: opacity 0.3s;
    opacity: 0;
  }

  @keyframes slide-in {
    from {
      transform: translateX(-100px);
    }
    to {
      transform: translateX(0px);
    }
  }

  @keyframes slide-out {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(-100px);
    }
  }

  .advanced > div {
    color: #999;
    padding: 5px;
    text-align: center;
  }

  .advanced .range {
    width: 50%;
  }

  .sx {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  .dx {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }

  .input-group input {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  .full {
    border-top-style: solid;
    border-width: thin;
    border-color: #444;
  }

  .noBorder {
    border-style: none;
  }

  .control-sidebar {
    -webkit-transition: -webkit-transform 0.3s ease-in-out, width 0.3s ease-in-out;
    -moz-transition: -moz-transform 0.3s ease-in-out, width 0.3s ease-in-out;
    -o-transition: -o-transform 0.3s ease-in-out, width 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue?d4bdfbb2